import React from 'react';
import { ListProperty } from './types';

type Props = {
  property: ListProperty;
};

export function ListPropertyValue({ property }: Props) {
  return <>{property.values?.filter(Boolean).join(', ')}</>;
}
